import {
  Mediator
} from 'application/src/js/util.js';

export default class ResultTabs extends Mediator {
  constructor(element) {
    super();

    this.element = element;
    this.outerToggle = this.element.querySelector('.outer-toggle');
    this.activeLabelOut = this.outerToggle.querySelector('.active-label');
    this.toggle = this.outerToggle.querySelector('.toggle');
    this.labelsContainer = this.element.querySelector('.labels');
    this.labels = this.labelsContainer.querySelectorAll('.label');
    this.activeLabel = this.labelsContainer.querySelector('.active');
    if (!this.activeLabel) return;
    this.toggleLabel = this.activeLabelOut.insertAdjacentElement('beforeend', this.activeLabel.cloneNode(true));

    this.activeClass = 'active';
    this.openClass = 'open';
    this.disabledClass = 'disabled';

    this.breakpoint = 800; // css breakpoint in pixel; this is the screen width where the dropdown becomes a horizontal menu

    this.addEvents();
  }

  addEvents() {
    [...this.labels].map(label => {
      label.addEventListener('click', e => {
        this.activeLabel.classList.remove(this.activeClass);
        label.classList.add(this.activeClass);
        this.activeLabel = label;
        this.toggleLabel = this.activeLabel.cloneNode(true);
        this.activeLabelOut.innerHTML = '';
        this.activeLabelOut.insertAdjacentElement('beforeend', this.toggleLabel);

        if (this.isMobileView()) {
          this.close();
          window.setTimeout(_ => {
            this.element.scrollIntoView({
              behaviour: 'smooth',
              block: 'center'
            });
          }, 50);
        }

        this.publish('change', this);
      });
    });

    this.toggle.addEventListener('click', e => this.element.classList.toggle(this.openClass));

    window.addEventListener('click', e => {
      if (!this.isMobileView()) return;
      if (this.element !== e.target & !this.element.contains(e.target)) this.close();
    });

    ['resize', 'orientationchange'].map(eventType => {
      window.addEventListener(eventType, e => {
        if (!this.isMobileView()) this.close();
      });
    });
  }

  close() {
    this.element.classList.remove(this.openClass);
    return this;
  }

  isMobileView() {
    return window.innerWidth < this.breakpoint;
  }

  gotoTabIndex(tabIndex) {
    this.activeLabel.classList.remove(this.activeClass);
    [...this.labels][tabIndex].classList.add(this.activeClass);
    this.activeLabel = [...this.labels][tabIndex];
    this.publish('change', this);
  }
}